<div class="header-content row overview-items">
  <div class="col-xs-12 col-md-6 col-xl-4 overview-item">
    <mat-card class="widget">
      @if (promotionAction) {
        <h1 class="title header-promotion" slot="header">{{ 'sebbie_ranking.promotion_action' | translate }}</h1>
        <div class="promotion-content" slot="content">
          <h2 class="promotion-title">{{ promotionAction.title || '-' }} </h2>
          <div class="date">
            <mat-icon>event_available</mat-icon>
            <span>
              {{promotionAction.startDate | date: "dd-MM-yy"}}
              {{ "general.to" | translate }}
              {{promotionAction.expirationDate | date: "dd-MM-yy"}}
            </span>
          </div>
          <div class="description">
            <p>{{promotionAction.description}}</p>
          </div>
          <button mat-flat-button (click)="openPromotionDialog()">{{ "page.detail.buttons.read_more" | translate }}</button>
        </div>
      } @else {
        <h1 class="title no-promotion-title" slot="header">{{ 'sebbie_ranking.promotion_action' | translate }}</h1>
        <div class="promotion-content" slot="content">
          <h1 class="no-promotion">{{ 'sebbie_ranking.no_promotion_description' | translate }}</h1>
        </div>
      }
    </mat-card>
  </div>

  <div class="col-xs-12 col-md-6 col-xl-4 overview-item">
    <mat-card class="widget">
      @if (availableTaskIds?.length > 0) {
        <h1 class="title" slot="header">{{ isCurrentPromotion ? ('sebbie_ranking.my_tasks' | translate) : ('sebbie_ranking.achieved_tasks' | translate) }}</h1>
        <div class="task-content" slot="content">
          @for (taskId of availableTaskIds; track taskId; let i = $index) {
            <div class="task-image-container">
              <svg
                width="60" height="64" viewBox="0 0 60 64"
                        [ngClass]="{
                            'empty': false,
                            'completed': isTaskCompleted(taskId)
                        }">
                <path d="M30 0C30.575 0 31.15 0.125 31.675 0.3625L55.2125 10.35C57.9625 11.5125 60.0125 14.225 60 17.5C59.9375 29.9 54.8375 52.5875 33.3 62.9C31.2125 63.9 28.7875 63.9 26.7 62.9C5.1625 52.5875 0.0624958 29.9 -4.179e-06 17.5C-0.0125042 14.225 2.0375 11.5125 4.7875 10.35L28.3375 0.3625C28.85 0.125 29.425 0 30 0Z"/>
              </svg>
              <span>{{i+1}}</span>
            </div>
          }
        </div>
      } @else {
        <h1 class="title" slot="header">{{ 'sebbie_ranking.no_tasks' | translate }}</h1>
        <div class="task-content" slot="content">
          @for (_ of [].constructor(9); track _; let i = $index) {
            <div class="task-image-container">
              <svg
                width="60" height="64" viewBox="0 0 60 64"
                class="empty">
                <path d="M30 0C30.575 0 31.15 0.125 31.675 0.3625L55.2125 10.35C57.9625 11.5125 60.0125 14.225 60 17.5C59.9375 29.9 54.8375 52.5875 33.3 62.9C31.2125 63.9 28.7875 63.9 26.7 62.9C5.1625 52.5875 0.0624958 29.9 -4.179e-06 17.5C-0.0125042 14.225 2.0375 11.5125 4.7875 10.35L28.3375 0.3625C28.85 0.125 29.425 0 30 0Z"/>
              </svg>
              <span>{{i+1}}</span>
            </div>
          }
        </div>
      }
    </mat-card>
  </div>

  <div class="col-xs-12 col-md-12 col-xl-4 overview-item">
    <mat-card class="widget">
      <h1 class="title">{{ isCurrentPromotion ? ('sebbie_ranking.achieved_sebbies' | translate) : ('sebbie_ranking.collected_sebbies' | translate) }}</h1>
      <div class="sebbies-content" slot="content">
        <img
          src="assets/images/sebbies/Spots-stack.png"
          alt="Sebbies"
          />
          <span>{{spotsReceived}}</span>
        </div>
      </mat-card>
    </div>
  </div>